import { useContext, useEffect, useState } from "react"
import { BookingContainer } from "../components/BookingContainer";
import { ApplicationUserContext, OfficeContext } from "../../../config/Context";
import { datesAreOnSameDay, from_YYYYMMDDHHMMSS, prettyDate} from "../../../config/dateFormatting";
import { FrontendApi } from "../../../planEatApi/FrontendApi";
import { IAlreadyBooked, IMenuItem, IMyBookingsListItem } from "../../../interface/interface";
import { planEatApi } from "../../../planEatApi/PlanEatApi";
import { IBookingContent, IBookingItemContent, IDishContent, IEaterGroupContent, IOfficeContent, IPriceModelContent, ISeatingContent, IUserContent, IVersionedObject } from "../../../planEatApi/PlanEatFacade";
import { v4 as uuidv4 } from 'uuid';
import { CheckOutPaymentContainer } from "../components/CheckOutPaymentContainer";
import { MdOutlineChevronLeft, MdOutlineChevronRight } from 'react-icons/md';
import { MyBookingsListItem } from "../components/MyBookingsListItem";
import { HamburgerMenu } from '../../../components/ui/HamburgerMenu';
import { ConfirmWeekChangeModal } from "../../../components/modals/ConfirmWeekChangeModal";
import { EditBookingModal } from "../../../components/modals/EditBookingModal";
import toast from "react-hot-toast";
import { isBookingDisabled } from "../../../utils/isBookingDisabled";
import { Logo } from "../../../components/ui/Logo";
import { icon_hamburger } from "../../../assets/images/images";
import { WeekPicker } from "../../../components/ui/WeekPicker";
import { Button, makeStyles } from '@material-ui/core';
import clsx from "clsx";
import { EditWeekBookingModal } from "../../../components/modals/EditBookingModalV2";
import { getSeatingsOnDate } from "../../../utils/getSeatingsOnDate";
import { extractErrorMessage } from "../../../components/utils/ErrorHandler";

const useStyles = makeStyles((theme: any) => ({
    container: {
        display: 'flex',
        justifyContent: 'center',
        padding: 15,
        width: "100% !important",
        alignItems: "center",
        
        "& > *": {
            maxWidth: 1600,
            minWidth: 1370,
        }
    },
    topBarContainer:{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 15
    },
    topRowContainer:{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    select:{
        outline: 'none',
        border: 'none',
        fontWeight: 'bold'
    },
    title: {
        fontWeight: 'bold',
        fontSize: 22, 
        marginBottom: 25
    },
    weekDaysContainer:{
        display: 'grid',
        gridTemplateColumns:'repeat(5, 1fr)',
        columnGap: 15,
        marginBottom: 75
    },
    bookingOverviewContainer:{
        display: 'flex',
        justifyContent: 'center',
        position: "fixed",
        bottom: 0,
        left: 0,
        zIndex: 20,
        height: 140,
        width: "100%",


        color: "white",
        background: "linear-gradient(90deg, #6178ED 0%, #9354F9 94%)",

        "& > *":{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: "100%",
            lineHeight: 0,
            maxWidth: 1600,

            paddingLeft: 25,
            paddingRight: 25,
            paddingTop: 10,
            paddingBottom: 10,
        }
    },
    toCheckOutTitleContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        fontSize: 20,
        fontWeight: 700,
        height: '100%',

        "&:hover":{
            opacity: 0.5,
            cursor: "pointer"
        }
    },
    disabled:{
        pointerEvents: 'none',
        opacity: 0.5
    },
    bottomOverviewPriceContainer:{
        display: 'flex',
        alignItems: 'baseline',
        justifyContent: 'center',
        lineHeight: 0,
        fontSize: 12,
        height: "fit-content"
    },
    checkoutContainer:{
        display: 'grid',
        gridTemplateColumns: "60% 30%",
        columnGap: "10%",
        width: "100%"
    },
    checkoutPriceTotalContainer:{
        display: 'flex',
        alignItems: 'baseline',
        justifyContent: 'space-between',
        fontSize: 18,
        fontWeight: 700,
        lineHeight: 1,
        paddingTop: 25,
        paddingBottom: 25,

        "&>*":{
            display: 'flex',
            alignItems: 'baseline',
        }
    },
    checkoutRightSideContainer:{
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'column',
        borderLeft:  "1px dashed rgba(11, 37, 89, 0.2)",
        paddingLeft: 25,

        "&>*":{
            marginBottom: 30
        }
    }
}));

export const WeekBooking = () => {
    // Styling
    const classes = useStyles()

    // Date mechanism
    const [date,setDate] = useState(new Date);
    const [selectedDate, setSelectedDate] = useState<Date>();
    const [weekDates, setWeekDates] = useState<Date[]>([]);
    const [menuItemsOnDates,setMenuItemsOnDates] = useState<IMenuItem[][]>([])
    const [confirmWeekChangeModalHidden, setConfirmWeekChangeModalHidden] = useState(true);
    const [seatingsAvaialable, setSeatingsAvaialable] = useState<Map<string,string>>(new Map())
    const [seatingCapacities, setSeatingCapacities] = useState<Map<string,string>>(new Map())

    // Office Context
    const officeContext = useContext(OfficeContext);
    const applicationUserContext = useContext(ApplicationUserContext)

    // Bookings
    const [bookingContainersView,setBookingContainersView] = useState<any[]>([]);
    const [priceTotal,setPriceTotal] = useState(0);
    const [isCreatingBooking, setIsCreatingBooking] = useState(false)

    // Upcoming bookinggs
    const [upcomingBookings, setUpcomingBookings] = useState<IMyBookingsListItem[]>([]);
    const [upcomingBookingsView, setUpcomingBookingsView] = useState<any[]>([]);
    
    // Check-out
    const [isItemsSelected, setIsItemsSelected] = useState(false);
    const [isBookedCorrectly,setIsBookedCorrectly] = useState(false);
    const [atCheckOut,setAtCheckOut] = useState(false);
    const [checkOutView,setCheckOutView] = useState<any[]>([]);

    // Hamburger menu
    const [open, setOpen] = useState(false);
    const [increase, setIncrease] = useState(true);

    // Entities
    const [users, setUsers] = useState<IVersionedObject<IUserContent>[]>([]);
    const [eaterGroups, setEaterGroups] = useState<IVersionedObject<IEaterGroupContent>[]>([]);
    const [offices, setOffices] = useState<IVersionedObject<IOfficeContent>[]>([]);
    const [seatings,setSeatings] = useState<IVersionedObject<ISeatingContent>[]>([]);
    const [seatingsOnDate, setSeatingsOnDate] = useState<IVersionedObject<ISeatingContent>[]>([])
    const [bookings,setBookings] = useState<IVersionedObject<IBookingContent>[]>([]);
    const [booking, setBooking] = useState<IBookingContent>();
    const [dishes,setDishes] = useState<IVersionedObject<IDishContent>[]>([]);
    const [priceModels,setPriceModels] = useState<IVersionedObject<IPriceModelContent>[]>([]);

    /*Get required info */
    async function getDatabase(){
        if(officeContext?.office){
            var tmpSeatings = await planEatApi.getSeatings()
            .then((response) => {setSeatings(response.data.filter(seating => seating.content.officeId === officeContext?.office?.content.id));return response.data.filter(seating => seating.content.officeId === officeContext?.office?.content.id)})
            .catch((e) => {console.log(e)});
    
            var tmpBookings = await planEatApi.getBookings()
            .then((response) => {setBookings(JSON.stringify(bookings) !== JSON.stringify(response.data) ? response.data : bookings);return response.data})
            .catch((e) => {console.log(e)});
            
            var tmpDishes = await planEatApi.getDishes()
            .then((response) => {setDishes(JSON.stringify(dishes) !== JSON.stringify(response.data) ? response.data : dishes);return response.data})
            .catch((e) => {console.log(e)});
    
            var tmpPriceModels = await planEatApi.getPriceModels()
            .then((response) => {setPriceModels(JSON.stringify(priceModels) !== JSON.stringify(response.data) ? response.data : priceModels);return response.data})
            .catch((e) => {console.log(e)});
    
            var tmpUsers = await planEatApi.getUsers()
            .then((response) => {setUsers(JSON.stringify(users) !== JSON.stringify(response.data) ? response.data : users);return response.data})
            .catch((e) => {console.log(e)});
    
            var tmpEaterGroups = await planEatApi.getEaterGroups()
            .then((response) => {setEaterGroups(JSON.stringify(eaterGroups) !== JSON.stringify(response.data) ? response.data : eaterGroups);return response.data})
            .catch((e) => {console.log(e)});
    
            var tmpOffices = await planEatApi.getOffices()
            .then((response) => {setOffices(JSON.stringify(offices) !== JSON.stringify(response.data) ? response.data : offices)})
            .catch((e) => {console.log(e)});
    
            if(tmpSeatings && tmpDishes && tmpBookings && tmpPriceModels){
                getMenuItemsOnDate(tmpSeatings,tmpDishes,tmpBookings,tmpPriceModels)
            }
    
            if(tmpBookings && tmpSeatings && tmpDishes){
                getUpcomingBookings(tmpBookings,tmpSeatings,tmpDishes)
            }
        }
    }

    useEffect(() => {
        if(weekDates && officeContext?.office){
            getDatabase()
        }
    },[weekDates,officeContext])

    const getMenuItemsOnDate = (
        tmpSeatings: IVersionedObject<ISeatingContent>[],
        tmpDishes: IVersionedObject<IDishContent>[],
        tmpBookings: IVersionedObject<IBookingContent>[],
        tmpPriceModels: IVersionedObject<IPriceModelContent>[]) => {
        var tmpMenuItemsOnDates : IMenuItem[][] = []

        if(weekDates.length > 0){
            weekDates.forEach(async (weekDate) => {
                if(officeContext?.office){
                    await FrontendApi.getMenuItemsOnDate(weekDate,officeContext?.office.content.id,tmpSeatings,tmpDishes,tmpBookings,tmpPriceModels)
                    .then((response) => {
                        tmpMenuItemsOnDates.push(response)

                        if(tmpMenuItemsOnDates.length === 5){
                            setMenuItemsOnDates(tmpMenuItemsOnDates)
                        }
                    })
                    .catch((e) => {
                        console.log(e)
                    })
                }
            })
        }
    }

    const getUpcomingBookings = async (
        tmpBookings: IVersionedObject<IBookingContent>[],
        tmpSeatings: IVersionedObject<ISeatingContent>[],
        tmpDishes: IVersionedObject<IDishContent>[]
    ) => {
        setUpcomingBookings(await FrontendApi.getMyBookingsList(true, false, tmpBookings, tmpSeatings, tmpDishes));
    }

    useEffect(() => {
        displayUpcomingBookings();
    },[upcomingBookings])
    
    useEffect(() => {
        if(menuItemsOnDates.length === 5){
            getAvailableDays();
            getSeatingCapacities();
            calculateTotal();
            getBookedCorrectly();
            checkIsItemsSelected();
            sortMenuItemsOnDate();
        } 
    },[menuItemsOnDates])

    function getAvailableDays(){
        var seatingIds: string[] = []
        menuItemsOnDates.forEach(menuItemsOnDate => {
            menuItemsOnDate.forEach(menuItemOnDate => {
                menuItemOnDate.selectableSeatings.forEach(selectableSeating => {
                    if(!seatingIds.includes(selectableSeating.seating.content.id)){
                        seatingIds.push(selectableSeating.seating.content.id)
                    }
                })
            })
        })

        if(seatingIds && seatingIds.length > 0){
            planEatApi.getCutOffTime(seatingIds)
            .then(response => {
                var tmpResponse: Object = JSON.parse(JSON.stringify(response.data))
                if(new Map<string,string>(Object.entries(tmpResponse)) !== seatingsAvaialable){
                    setSeatingsAvaialable(new Map<string,string>(Object.entries(tmpResponse)))
                }
            })
            .catch(e => {
                console.log(e)
            })
        }
    }

    function getSeatingCapacities(){
        var seatingIds: string[] = []
        menuItemsOnDates.forEach(menuItemsOnDate => {
            menuItemsOnDate.forEach(menuItemOnDate => {
                menuItemOnDate.selectableSeatings.forEach(selectableSeating => {
                    if(!seatingIds.includes(selectableSeating.seating.content.id)){
                        seatingIds.push(selectableSeating.seating.content.id)
                    }
                })
            })
        })

        if(seatingIds.length > 0){
            planEatApi.getSeatingCapacities(seatingIds)
            .then(response => {
                var tmpResponse: Object = JSON.parse(JSON.stringify(response.data))
                if(new Map<string,string>(Object.entries(tmpResponse)) !== seatingCapacities){
                    setSeatingCapacities(new Map<string,string>(Object.entries(tmpResponse)))
                }
                
            })
            .catch(e => {
                console.log(e)
            })
        }
    }

    useEffect(() => {
        displayBookingContainers()
    },[seatingCapacities, seatingsAvaialable, menuItemsOnDates])


    const displayBookingContainers = () => {
        if(seatings && offices && users && bookings){
            var userId = localStorage.getItem("userId");
            if(userId){
                if(weekDates.length > 0){
                    var tmpBookingContainersView : any[] = []
        
                    weekDates.forEach((weekDate,index) => {
                        var alreadyBookings: IAlreadyBooked[] = [];
                        var alreadyBookedOnDate = false;
                        seatings.forEach(seating => {
                            var seatingDate = from_YYYYMMDDHHMMSS(seating.content.seatingStart)
                            if(datesAreOnSameDay(seatingDate,weekDate)){
                                bookings.forEach(booking => {
                                    if(booking.content.seatingId === seating.content.id){    
                                        if(booking.content.userId === userId){
                                            alreadyBookedOnDate = true;
                                            offices.forEach(office => {
                                                if(office.content.id=== seating.content.officeId){
                                                    var alreadyBooking: IAlreadyBooked = {
                                                        quantity: booking.content.bookingItems.length,
                                                        seatingId: seating.content.id,
                                                        seatingName: seating.content.seatingName,
                                                        seatingTime: prettyDate(seating.content.seatingStart, true, false),
                                                        officeName: office.content.officeName,
                                                    }
                                                    alreadyBookings.push(alreadyBooking)
                                                }
                                            })
                                        }
                                    }
                                })
                            }
                        })
    
                        var eaterGroupBookings: IAlreadyBooked[] = [];
                        var currentUser = users.find(user => user.content.id=== userId)
                        var eaterGroupUsers: IVersionedObject<IUserContent>[] = []
                        if(currentUser){
                            users.forEach(user => {
                                if(user.content.eaterGroupId=== currentUser?.content.eaterGroupId){
                                    eaterGroupUsers.push(user)
                                }
                            })

                            // Sort by seating time
                            seatings.sort((a,b) => from_YYYYMMDDHHMMSS(a.content.seatingStart).getTime() - from_YYYYMMDDHHMMSS(b.content.seatingStart).getTime())

                            seatings.forEach(seating => {
                                // Already booked parameters
                                var quantity: number = 0;
                                var officeName: string = "";

                                var seatingDate = from_YYYYMMDDHHMMSS(seating.content.seatingStart)
                                if(datesAreOnSameDay(seatingDate,weekDate)){
                                    bookings.forEach(booking => {
                                        if(booking.content.seatingId === seating.content.id){
                                            eaterGroupUsers.forEach(eaterGroupUser => {
                                                if(booking.content.userId === eaterGroupUser.content.id && booking.content.userId !== userId){
                                                    quantity += booking.content.bookingItems.length;
                                                    
                                                    offices.forEach(office => {
                                                        if(office.content.id=== seating.content.officeId){
                                                            officeName = office.content.officeName;
                                                        }
                                                    })
                                                }
                                            })    
                                        }
                                    })
                                }

                                if(quantity > 0 && officeName !== ''){
                                    var alreadyBooking: IAlreadyBooked = {
                                        quantity: quantity,
                                        seatingId: seating.content.id,
                                        seatingName: seating.content.seatingName,
                                        seatingTime: prettyDate(seating.content.seatingStart, true, false),
                                        officeName: officeName,
                                    }
                                    eaterGroupBookings.push(alreadyBooking)
                                }
                            })
                        }

                        var eaterGroupName = eaterGroups.find(eaterGroup => eaterGroup.content.id === currentUser?.content.eaterGroupId)?.content.eaterGroupName;
                        tmpBookingContainersView.push(
                            <BookingContainer 
                                key={weekDate.toDateString()} 
                                date={weekDate}
                                menuItemsOnDates={menuItemsOnDates} 
                                setMenuItemsOnDates={setMenuItemsOnDates} 
                                index={index} 
                                alreadyBookedOnDate={alreadyBookedOnDate} 
                                alreadyBookings={alreadyBookings}
                                eaterGroupBookings={eaterGroupBookings}
                                eaterGroupName={eaterGroupName ? eaterGroupName : "Eater Group"}
                                seatingAvaiable={seatingsAvaialable}
                                seatingCapacities={seatingCapacities}
                            />
                        )
                    })
        
                    if(tmpBookingContainersView){
                        setBookingContainersView(tmpBookingContainersView)
                    }
                }
            }
        }
    }


    function calculateTotal() {
        let tmp_price: number = 0;

        if(menuItemsOnDates.length > 0){
            menuItemsOnDates.forEach(menuItemsOnDate => {
                menuItemsOnDate.forEach((menuItemOnDate) => {
                    if(menuItemOnDate.quantity > 0){
                        tmp_price += menuItemOnDate.price * menuItemOnDate.quantity
                    }
                })
            })
        }
        setPriceTotal(tmp_price)
    }

    function sortMenuItemsOnDate(){
        var tmpMenuItemsOnDates : IMenuItem[][] = []

        weekDates.forEach((weekDate,index) => {
            let indexOfMenuItemOnDate = 0;
            for (var i = 0; i < menuItemsOnDates.length; i++) {
                menuItemsOnDates[i].forEach(menuItemOnDate => {
                    if(datesAreOnSameDay(weekDate,menuItemOnDate.date)){
                        indexOfMenuItemOnDate = i
                    }
                })
            }
            tmpMenuItemsOnDates.push(menuItemsOnDates[indexOfMenuItemOnDate])
        }) 
        
        var isDifferent = false;
        menuItemsOnDates.forEach((menuItemsOnDate,i) => {
            menuItemsOnDate.forEach((menuItemOnDate,j) => {
                if(menuItemOnDate !== tmpMenuItemsOnDates[i][j]){
                    isDifferent = true;
                }
            })
        })
        if(isDifferent && tmpMenuItemsOnDates.length > 0){
            setMenuItemsOnDates(tmpMenuItemsOnDates)
        }
    }

    function getBookedCorrectly() {
        var tmpIsCorrectlyBooked = true;
        menuItemsOnDates.forEach((menuItemsOnDate,i) => {
            menuItemsOnDate.forEach((menuItemOnDate,j) => {
                if(menuItemOnDate.quantity > 0){
                    let singleSeatingSelected = 0;

                    menuItemOnDate.selectableSeatings.forEach((selectableSeating) => {
                        if(selectableSeating.selected){
                            singleSeatingSelected += 1;
                        }
                    })
    
                    if(singleSeatingSelected !== 1){
                        tmpIsCorrectlyBooked = false;
                    }
                }
            })
        })
        setIsBookedCorrectly(tmpIsCorrectlyBooked)
    }

    useEffect(() => {
        if(atCheckOut){
            displayCheckOutItems()
        }   
    },[atCheckOut])

    function displayCheckOutItems(){
        var tmpCheckOutItemsView : any[] = []

        menuItemsOnDates.forEach((menuItemsOnDate) => {
            var dateSet = false;
            menuItemsOnDate.forEach((menuItemOnDate,index) => {
                if(menuItemOnDate.quantity > 0){
                    if(!dateSet){
                        dateSet = true;
                        tmpCheckOutItemsView.push(<b style={{display:"flex",justifyContent:"flex-start",width:"600px"}}>{prettyDate(menuItemOnDate.date,false,true)}</b>)
                    }

                    // Add Checkout items
                    menuItemOnDate.selectableSeatings.forEach((selectableSeating) => {
                        if (selectableSeating.selected) {
                            tmpCheckOutItemsView.push(
                                <div>
                                    <div style={{display:"flex",justifyContent:"space-between",width:'100%'}}>
                                        <div>
                                            <div>{selectableSeating.seating.content.seatingName} | {prettyDate(from_YYYYMMDDHHMMSS(selectableSeating.seating.content.seatingStart),true,false)}</div>
                                            <div>{menuItemOnDate.quantity} x person | {menuItemOnDate.dish.content.dishTitle}</div>
                                        </div>
                                        <div className={classes.checkoutPriceTotalContainer} hidden={menuItemOnDate.price=== 0}>
                                            {menuItemOnDate.quantity * menuItemOnDate.price} <div style={{fontSize:10,fontWeight:400}}>DKK</div>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    })
                }
            })
        })
        setCheckOutView(tmpCheckOutItemsView)
    }

    function createBookings(){
        setIsCreatingBooking(true)
        let booking_count = 0;
        menuItemsOnDates.forEach((menuItemsOnDate) => {
            menuItemsOnDate.forEach((menuItemOnDate) => {
                if(menuItemOnDate.quantity > 0){
                    menuItemOnDate.selectableSeatings.forEach(async (selectableSeating) => {
                        if(selectableSeating.selected){
                            var userId = localStorage.getItem("userId")
                            
                            if(userId){
                                let bookingItems: IBookingItemContent[] = []
                                for (let i = 0; i < menuItemOnDate.quantity; i++) {
                                    const bookingItem: IBookingItemContent = {
                                        'bookingItemId': uuidv4(),
                                        'dishId': menuItemOnDate.dish.content.id,
                                        'dishVersion': menuItemOnDate.dish.version
                                    };
                                    bookingItems.push(bookingItem)
                                }

                                var booking: IBookingContent = {
                                    id: '',
                                    name: "",
                                    description: "",
                                    userId: userId,
                                    seatingId: selectableSeating.seating.content.id,
                                    seatingVersion: selectableSeating.seating.version,
                                    bookingPricePerServing: 0,
                                    bookingComment: menuItemOnDate.comment ? menuItemOnDate.comment : "",
                                    bookingItems: bookingItems,
                                }

                                booking_count += 1
                                await planEatApi.postBooking(booking)
                                .then(response => {
                                    booking_count -= 1
                                    setAtCheckOut(false);
                                    getDatabase();
                                    toast.success("Created booking at: " + prettyDate(from_YYYYMMDDHHMMSS(selectableSeating.seating.content.seatingStart),true,true),{duration:4000})
                                })
                                .catch(e => {
                                    booking_count -= 1
                                    if(e.response.data.content.length > 0){
                                        toast.error(e.response.data.content[e.response.data.content - 1].message)
                                    } else {
                                        toast.error("Failed creating booking at: " + prettyDate(from_YYYYMMDDHHMMSS(selectableSeating.seating.content.seatingStart),true,true),{duration:4000})
                                    }
                                })
                            }          
                        }
                    })
                }
            })
        })

        if(booking_count == 0){
            setIsCreatingBooking(false)
        }
    }

    const handleEdit = async (seatingStart: Date, bookingId: string) => {
        /* Set parameters form edit modal */
        setSelectedDate(seatingStart)
        setSeatingsOnDate(getSeatingsOnDate(seatingStart,seatings))

        planEatApi.getBooking(bookingId)
        .then(response => {
            setBooking(response.data.content)
        })
        .catch(e => {
            console.log(e)
        });
    }

    const handleDelete = async (bookingId: string) => {
        await planEatApi.postDeleteForBooking(bookingId)
        .then(response => {
            toast.success("Booking was deleted")
            getDatabase()
        })
        .catch(e => {
            extractErrorMessage(e, "Failed creating booking")
        });
    }


    const displayUpcomingBookings = () => {
        let myBookingsView : any[] = []
        for (const [index, bookingListItem] of upcomingBookings.entries()) {
            var disabled = isBookingDisabled(bookingListItem.bookingId,seatings,bookings,priceModels)

            myBookingsView.push(
                <MyBookingsListItem 
                    key={bookingListItem.bookingId} 
                    bookingListItem={bookingListItem} 
                    handleDelete={() => handleDelete(bookingListItem.bookingId)} 
                    handleEdit={() => handleEdit(from_YYYYMMDDHHMMSS(bookingListItem.seatingStart),bookingListItem.bookingId,)} 
                    disabled={disabled}/>
            )
        }
        setUpcomingBookingsView(myBookingsView)
    }

    function updateBooking(updatedBooking: IBookingContent){
        const userId = localStorage.getItem("userId")
        if(userId){
            updatedBooking.userId = userId
            planEatApi.postBooking(updatedBooking)
            .then(response => {
                getDatabase()
                toast.success("Booking was updated")
                setBooking(undefined)
            })
            .catch(e => {
                extractErrorMessage(e, "Failed creating booking")
                getDatabase()
            })
        }
    }
       
    const updateWeekNumber = (tmpIncrease: boolean) => {
        // Set increase state
        setIncrease(tmpIncrease)

        var itemsSelected = false;
        menuItemsOnDates.forEach((menuItemsOnDate) => {
            menuItemsOnDate.forEach((menuItemOnDate) => {
                if(menuItemOnDate.quantity > 0) {
                    itemsSelected = true
                }
            })
        })

        if(!itemsSelected || isCreatingBooking){
            if (tmpIncrease) {
                date.setDate(date.getDate() + 7)
                setDate(new Date(date))
            } else {
                date.setDate(date.getDate() - 7)
                setDate(new Date(date))
            }
        } else {
            setConfirmWeekChangeModalHidden(false)
        }
    }

    const confirmUpdateWeek = () => {
        if (increase) {
            date.setDate(date.getDate() + 7)
            setDate(new Date(date))
        } else {
            date.setDate(date.getDate() - 7)
            setDate(new Date(date))
        }
        setConfirmWeekChangeModalHidden(true)
    }

    function checkIsItemsSelected(){
        let quantity: number = 0;

        if(menuItemsOnDates.length > 0){
            menuItemsOnDates.forEach(menuItemsOnDate => {
                menuItemsOnDate.forEach((menuItemOnDate) => {
                    quantity += menuItemOnDate.quantity
                })
            })
        }
       setIsItemsSelected(quantity > 0)
    }

    const handleOfficeChange = (event: React.FormEvent<HTMLSelectElement>) => {
        offices.map((office) => {
            if(office.content.id=== event.currentTarget.value){
                officeContext?.setOffice(office)
                localStorage.setItem("officeId",office.content.id)
            }
        })
    }

    return (
        <div className={classes.container} >
            <div>
                <div className={classes.topBarContainer}>
                    <Logo variant="small" />
                    {!atCheckOut? <WeekPicker date={date} setDate={setDate} setWeekDates={setWeekDates} updateWeekNumber={updateWeekNumber}/> : <div/>}
                    <img onClick={() => { setOpen(true) }} src={icon_hamburger} alt="hamburgerMenu" style={{ cursor: 'pointer' }} />
                </div>
                <div>
                    {!atCheckOut ?
                        <div>
                            <div className={classes.topRowContainer}>
                                <div className={classes.title}>
                                    New Booking
                                </div>
                                <div>
                                    {
                                        officeContext?.office &&
                                        <select
                                            id="demo-customized-button"
                                            aria-controls="demo-customized-menu"
                                            aria-haspopup="true"
                                            className={classes.select}
                                            onChange={handleOfficeChange}
                                            value={officeContext?.office.content.id}>
                                            {offices.map((office) => <option value={office.content.id}>{office.content.officeName}</option>)}
                                        </select>
                                    }
                                </div>
                            </div>    
                            <div className={classes.weekDaysContainer}>
                                {bookingContainersView}
                            </div>
                            <div>
                                {isItemsSelected ?
                                    <div className={classes.bookingOverviewContainer}>
                                        <div>   
                                            {
                                                priceTotal > 0 ?
                                                <div className={classes.bottomOverviewPriceContainer}>
                                                    <div style={{fontSize:28}}>{priceTotal}</div> <div>DKK</div>
                                                </div>
                                                :
                                                <div/>
                                            }
                                            {!isBookedCorrectly ?
                                                <div className={clsx(classes.toCheckOutTitleContainer,classes.disabled)}>
                                                    Continue <MdOutlineChevronRight fontSize="36px"/>
                                                </div>
                                                :
                                                <div className={classes.toCheckOutTitleContainer} onClick={() => {setAtCheckOut(true)}}>
                                                    Continue <MdOutlineChevronRight fontSize="36px"/>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    :
                                    <div></div>
                                }
                            </div>
                        </div>
                        :
                        <div className={classes.checkoutContainer}>
                            <div>
                                <div className={classes.title}>Checkout</div>
                                <div>
                                    {checkOutView}
                                </div>
                                
                            </div>   
                            <div className={classes.checkoutRightSideContainer}>
                                <CheckOutPaymentContainer  selected={true} title="Add to your account" description="Pay later by invoice"/>
                                <div className={classes.checkoutPriceTotalContainer} hidden={priceTotal=== 0  }>
                                    <div>
                                        TOTAL
                                    </div>
                                    <div>
                                        {priceTotal} <div style={{fontSize:10,fontWeight:400}}>DKK</div>
                                    </div>
                                </div>
                                <Button variant="contained" style={{width: '100%'}} onClick={() => {createBookings()}}>
                                    Confirm Order
                                </Button>
                                <Button variant="contained" style={{background: "#666666"}} onClick={() => {setAtCheckOut(false)}}>
                                    <MdOutlineChevronLeft fontSize="24px"/> Back
                                </Button> 
                            </div>
                        </div>
                    }
                </div>
                <div style={{marginBottom: 400,width: 350}}>
                    {
                        !atCheckOut &&
                        <div>  
                            <div className={classes.title}>Upcoming Bookings</div>
                            <div>
                                {upcomingBookingsView}
                            </div>
                        </div>
                    }
                </div>
                <div>
                    <HamburgerMenu open={open} setOpen={setOpen}></HamburgerMenu>
                </div>
                <div>
                    <ConfirmWeekChangeModal 
                        confirmFunction={confirmUpdateWeek}
                        confirmWeekChangeModalHidden={confirmWeekChangeModalHidden} 
                        setConfirmWeekChangeModalHidden={setConfirmWeekChangeModalHidden}/>
                </div>
                <div>
                    {
                        applicationUserContext && selectedDate && booking && setBooking &&
                        <EditWeekBookingModal 
                            date={selectedDate}
                            booking={booking}
                            setBooking={setBooking}
                            updateBooking={updateBooking}
                            seatingsOnDate={seatingsOnDate}
                            bookedBy={applicationUserContext.applicationServiceUser !== undefined ? applicationUserContext.applicationServiceUser?.content.name : "Username"}
                        />
                    }
                </div>
            </div>
        </div>
    )
}
